export default "__VITE_ASSET__8b557c80__"